module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/feature-2-icon-1.webp?97d22f87";